module.exports = __webpack_public_path__ + "img/covid_cases_27522.9945e81e.jpg";